import React from 'react';

const RightSideLoader = () => {
  return (
    <div className="py-1">
      <div className="">
        <div className="rounded-md p-2 mt-1  mx-auto">
          <div className="animate-pulse flex space-x-2">
            <div className="rounded-full bg-gray-400 h-8 w-8"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-2 bg-gray-400 rounded w-40"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-gray-400 rounded col-span-1 w-28"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-md p-2 mt-1  mx-auto">
          <div className="animate-pulse flex space-x-2">
            <div className="rounded-full bg-gray-400 h-8 w-8"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-2 bg-gray-400 rounded w-40"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-gray-400 rounded col-span-1 w-28"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-md p-2 mt-1  mx-auto">
          <div className="animate-pulse flex space-x-2">
            <div className="rounded-full bg-gray-400 h-8 w-8"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-2 bg-gray-400 rounded w-40"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-gray-400 rounded col-span-1 w-28"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-md p-2 mt-1  mx-auto">
          <div className="animate-pulse flex space-x-2">
            <div className="rounded-full bg-gray-400 h-8 w-8"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-2 bg-gray-400 rounded w-40"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-gray-400 rounded col-span-1 w-28"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-md p-2 mt-1  mx-auto">
          <div className="animate-pulse flex space-x-2">
            <div className="rounded-full bg-gray-400 h-8 w-8"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-2 bg-gray-400 rounded w-40"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-gray-400 rounded col-span-1 w-28"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-md p-2 mt-1  mx-auto">
          <div className="animate-pulse flex space-x-2">
            <div className="rounded-full bg-gray-400 h-8 w-8"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-2 bg-gray-400 rounded w-40"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-gray-400 rounded col-span-1 w-28"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-md p-2 mt-1  mx-auto">
          <div className="animate-pulse flex space-x-2">
            <div className="rounded-full bg-gray-400 h-8 w-8"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-2 bg-gray-400 rounded w-40"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-gray-400 rounded col-span-1 w-28"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSideLoader;